(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* ── Quick View ──────────────────────────── */
window.S3QuickView = function (card) {
  var imgSrc     = card.dataset.productImg    || '';
  var imgAlt     = card.dataset.productImgAlt || '';
  var url        = card.dataset.productUrl    || '#';
  var price      = card.dataset.productPrice  || '';
  var was        = card.dataset.productWas    || '';
  var desc       = card.dataset.desc          || '';

  var titleEl    = card.querySelector('.product-card__name a');
  var title      = titleEl ? titleEl.textContent.trim() : '';

  var ratingEl   = card.querySelector('.product-card__rating');
  var ratingHTML = ratingEl ? ratingEl.outerHTML : '';

  /* build modal once, reuse on every open */
  var modal = document.getElementById('s3-qv-modal');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 's3-qv-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Quick view');
    modal.innerHTML =
      '<div class="s3-qv__overlay"></div>' +
      '<div class="s3-qv__panel">' +
        '<button class="s3-qv__close" aria-label="Close">&times;</button>' +
        '<div class="s3-qv__img-wrap"><img class="s3-qv__img" src="" alt=""></div>' +
        '<div class="s3-qv__info">' +
          '<div class="s3-qv__rating-wrap"></div>' +
          '<h2 class="s3-qv__title"></h2>' +
          '<div class="s3-qv__prices">' +
            '<span class="s3-qv__price"></span>' +
            '<s class="s3-qv__was"></s>' +
          '</div>' +
          '<p class="s3-qv__desc"></p>' +
          '<a class="s3-qv__btn" href="#">VIEW FULL DETAILS &rarr;</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);
    modal.querySelector('.s3-qv__overlay').addEventListener('click', S3QVClose);
    modal.querySelector('.s3-qv__close').addEventListener('click', S3QVClose);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') S3QVClose();
    });
  }

  /* populate */
  var img    = modal.querySelector('.s3-qv__img');
  img.src    = imgSrc;
  img.alt    = imgAlt;

  modal.querySelector('.s3-qv__title').textContent     = title;
  modal.querySelector('.s3-qv__price').textContent     = price;
  modal.querySelector('.s3-qv__desc').textContent      = desc;
  modal.querySelector('.s3-qv__btn').href              = url;
  modal.querySelector('.s3-qv__rating-wrap').innerHTML = ratingHTML;

  var wasEl        = modal.querySelector('.s3-qv__was');
  wasEl.textContent  = was;
  wasEl.style.display = was ? '' : 'none';

  /* open */
  modal.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  modal.querySelector('.s3-qv__close').focus();
};

window.S3QVClose = function () {
  var modal = document.getElementById('s3-qv-modal');
  if (!modal) return;
  modal.classList.remove('is-open');
  document.body.style.overflow = '';
};
  } catch(e) { console.error(e); }
})();

})();
